import type { ButtonHTMLAttributes } from 'react';

// Shared version of the disabled-button+explanation pattern already used ad hoc by
// FlowsPage.transitionDisabledReason and VersionedCatalogPage.disabledHints: a button that
// disables itself and surfaces why via its title tooltip, instead of firing and failing with a
// raw backend error.
interface DisabledActionButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'disabled' | 'title' | 'type'> {
  reason: string | null;
}

export function DisabledActionButton({ reason, className, children, ...rest }: DisabledActionButtonProps) {
  return (
    <button type="button" className={className} disabled={Boolean(reason)} title={reason ?? undefined} {...rest}>
      {children}
    </button>
  );
}
